import { ApiClient } from '@/utils'
import { useAuthStore } from '@/stores'
import { determineAppropriateRootDomain } from '@/utils/cookie-utils'
import { type RouteLocationNormalized, type NavigationGuardNext } from 'vue-router'

/**
 * Cleans up tokens with .app.go2train.co domain
 * Returns true if any tokens were removed
 */
export function cleanupUnauthorizedTokens(): boolean {
  const UNAUTHORIZED_DOMAIN = '.app.go2train.co'
  const TOKEN_KEY = 'user_token'
  let tokensRemoved = false

  // Helper to remove a cookie with specific domain and all possible paths
  function removeCookieWithDomain(name: string, domain: string) {
    // Remove with different path combinations to ensure complete removal
    const paths = ['/', '/auth/sign-in', '']
    paths.forEach((path) => {
      document.cookie = `${name}=; domain=${domain}; path=${path}; expires=Thu, 01 Jan 1970 00:00:00 GMT; secure; samesite=none`
      document.cookie = `${name}=; domain=${domain}; path=${path}; expires=Thu, 01 Jan 1970 00:00:00 GMT;`
    })
  }

  try {
    // Specifically remove cookie from .app.go2train.co domain
    removeCookieWithDomain(TOKEN_KEY, UNAUTHORIZED_DOMAIN)
    tokensRemoved = true

    // Also clean local and session storage if we're on the unauthorized domain
    const currentDomain = determineAppropriateRootDomain()
    if (currentDomain?.includes('app.go2train.co')) {
      localStorage.removeItem(TOKEN_KEY)
      sessionStorage.removeItem(TOKEN_KEY)
    }

    return tokensRemoved
  } catch (error) {
    console.error('Error cleaning up app domain tokens:', error)
    return false
  }
}

// Updated authGuard implementation
export async function authGuard(
  to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext
) {
  const authStore = useAuthStore()

  // Clean up .app.go2train.co domain tokens before checking authorization
  const unauthorizedTokensRemoved = cleanupUnauthorizedTokens()
  if (unauthorizedTokensRemoved) {
    console.warn('App domain tokens were removed during navigation')
    // Force auth store to recheck authentication state
    authStore.restoreAuthState()
  }

  // Initialize API client authorization check
  ApiClient.checkAuthorization()

  try {
    if (to.meta.requiresAuth) {
      if (!authStore.isAuthenticated) {
        next({ name: 'sign-in' })
        return
      }
      // if (
      //   !authStore.hasAccess
      // ) {
      //   next({ name: 'sign-in' })
      //   return
      // }
    }

    // if (to.meta.isAuthRoute && authStore.isAuthenticated) {
    //   // If authenticated but no access, redirect to buy plan
    //   if (!authStore.hasAccess) {
    //     next({ name: 'buy-subscription' })
    //     return
    //   }
    //   // next({ name: 'user-subscriptions' })
    //   // return
    // }
    next()
  } catch (error) {
    console.error('Navigation guard error:', error)
    next({ name: 'sign-in' })
  }
}
